import format from 'date-fns/format'
import qs from 'qs'
import {call, put, select, take, takeEvery, takeLatest} from 'redux-saga/effects'

import * as apiActions from '../actions/api'
import * as eventsActions from '../actions/events'
import * as pcpActions from '../actions/productCategoryPage'
import * as productActions from '../actions/product'

import * as eventsSelectors from '../store/events'
import * as pcpSelectors from '../store/productCategoryPage'
import * as userSelectors from '../store/user'
import * as track from '../track/category'

import {CATEGORY_FILTER_PARAMS} from '../const'

export function* pcpHtoFilterWorker() {
  const isFilterSuccessful = yield select(pcpSelectors.filterSuccess)
  if (isFilterSuccessful) {
    yield put(pcpActions.categoryFilterFunnel())
  }
}

export function* pcpHtoFilterSaga() {
  yield takeLatest(
    [pcpActions.ENABLE_HTO_FILTER, pcpActions.DISABLE_HTO_FILTER, pcpActions.TOGGLE_HTO_FILTER],
    pcpHtoFilterWorker,
  )
}

export function* pcpQueryFilterWorker() {
  const {filter, partyFilter} = qs.parse(window.location.search, {
    ignoreQueryPrefix: true,
  })

  if (filter) {
    if (filter[CATEGORY_FILTER_PARAMS.HTO]) {
      yield put(pcpActions.enableHtoFilter())
    }
  }

  if (partyFilter) {
    const currentPartyFilter = yield select(pcpSelectors.currentPartyFilter)
    if (partyFilter === currentPartyFilter) return
    const filterThunk = yield call(pcpActions.filterByPartyType, partyFilter)
    yield put(filterThunk)

    if (partyFilter === 'Individual') {
      yield put(pcpActions.selectPartyIndividual())
    } else yield put(pcpActions.selectPartyGroup())
  }
}

export function* productCategoryPageLoadedWorker() {
  const categoryName = yield select(pcpSelectors.categoryName)
  yield call(pcpQueryFilterWorker)
  yield call(track.viewedProductCategory, categoryName)
}

export function* productCategoryPageLoadedSaga() {
  yield takeEvery(productActions.CATEGORY_OK, productCategoryPageLoadedWorker)
}

export function* pcpSetEventDateFilterDefaultWorker({type}) {
  const {eventDateFilter} = qs.parse(window.location.search, {ignoreQueryPrefix: true})

  const isAuthenticated = yield select(userSelectors.isAuthenticated)
  if (!isAuthenticated) return

  let eventDate = yield select(eventsSelectors.currentDate)

  if (eventDateFilter) {
    eventDate = eventDateFilter
    yield put(pcpActions.enableEventDateFilter())
  } else if (!eventDate) {
    // Get current event may still be in progress when this is fired, so we take GET_CURRENT_EVENT_SUCCESS.
    yield take(apiActions.GET_CURRENT_EVENT_SUCCESS)
    eventDate = yield select(eventsSelectors.currentDate)
  }

  // Appending time so date is parsed with local time
  const activeEventDate = new Date(`${eventDate}T00:00:00`)

  const currentFilterValue = yield select(pcpSelectors.selectedEventDate)

  // If active event date is the same as existing current filter value, do not update.
  // Since this worker may also run when the current event is updated, this prevents re-filtering
  // if some non-date aspect of the event was updated.
  const isUpdate = type === eventsActions.UPDATE_CURRENT_EVENT
  const isSameDate =
    format(activeEventDate, 'YYYY-MM-DD') === format(currentFilterValue, 'YYYY-MM-DD')
  if (isUpdate && isSameDate) return

  // Set selected event date in date filter
  yield put(pcpActions.selectEventDate(activeEventDate))

  // Filter by event date (filterByEventDate is a thunk)
  const filterThunk = yield call(pcpActions.filterByEventDate)
  yield put(filterThunk)
}

/**
 * In addition to the SET_EVENT_DATE_FILTER_DEFAULT action, we need to take UPDATE_CURRENT_EVENT to
 * apply the new updated event date to the filter (when event details are saved), RESET_ALL_FILTERS
 * to ensure that the reset event date is the active event date when applicable (when clicking reset), and
 * GET_CURRENT_EVENT_SUCCESS to apply the updated event date when getting the current event (after onboarding).
 */
export function* pcpSetEventDateFilterDefaultSaga() {
  yield takeLatest(
    [
      pcpActions.SET_EVENT_DATE_FILTER_DEFAULT,
      eventsActions.UPDATE_CURRENT_EVENT,
      pcpActions.RESET_ALL_FILTERS,
      apiActions.GET_CURRENT_EVENT_SUCCESS,
    ],
    pcpSetEventDateFilterDefaultWorker,
  )
}
